<template>
  <div>
    <default-card>
      <template slot="title-left"> </template>
      <template slot="title-right"> </template>
      <template slot="content">
        <v-row class="px-5 d-flex justify-space-between">
          
          <v-col cols="12" lg="3" md="6" sm="12">
            <card-loading flat v-if="loadings.income" card_color="white" text_color="primary--text" loading_color="primary"/>
            <received :data="all_data.income" style="height: 100%" v-if="!loadings.income"/>
          </v-col>

          <v-col cols="12" lg="3" md="6" sm="12">
            <card-loading flat v-if="loadings.outcome" card_color="white" text_color="primary--text" loading_color="primary"/>
            <expenditure :data="all_data.outcome" style="height: 100%" v-if="!loadings.outcome"/>
          </v-col>
          
          <v-col cols="12" lg="3" md="6" sm="12">
            <card-loading flat v-if="loadings.goals" card_color="white" text_color="primary--text" loading_color="primary"/>
            <goal style="height: 100%" :data="all_data.goals" v-if="!loadings.goals && all_data.goals"/>
          </v-col>

          <div class="py-6">
            <v-divider
            vertical
            ></v-divider>
          </div>

          <v-col cols="12" lg="3" md="6" sm="12">
            <card-loading flat v-if="loadings.balance" card_color="white" text_color="primary--text" loading_color="primary"/>
            <balance-avaliable :data="all_data.balance" style="height: 100%" v-if="!loadings.balance"/>
          </v-col>
          

          <!--<v-col cols="12" lg="3" md="6">
            <card-loading v-if="loadings.savings" card_color="white" text_color="primary--text" loading_color="primary"/>
            <reservation :data="all_data.savings" style="height: 100%" v-if="!loadings.savings"/>
          </v-col>-->

        </v-row>
      </template>
      <template slot="actions"> </template>
    </default-card>
  </div>
</template>

<script>
import Api from '@/api'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'FinanceInfo',

  components: {
    CalendarDatePicker: () => import ('../../events_agenda/calendar/CalendarDatePicker.vue'),
    BalanceAvaliable: () => import('./finance_cards/BalanceAvaliable.vue'),
    Received: () => import('./finance_cards/Received.vue'),
    Expenditure: () => import('./finance_cards/Expenditure.vue'),
    Goal: () => import('./finance_cards/Goal.vue'),
    Reservation: () => import('./finance_cards/Reservation.vue'),
  },

  props: {
    start_date: {
      type: String,
      default: ''
    },
    end_date: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      loading: false,
      loadings: {
        balance: false,
        income: false,
        outcome: false,
        goals: false,
        //savings: false,
      },
      all_data: {
        balance: null,
        income: null,
        outcome: null,
        goals: null,
        //savings: null,
      }
    }
  },

  methods: {
    // setStartEndDay(month){
    //   this.start_date = this.$dayjs(month).startOf('month').format('YYYY-MM-DD')
    //   this.end_date = this.$dayjs(month).endOf('month').format('YYYY-MM-DD')
    //   this.$emit('changeStartAndEndDate',this.start_date,this.end_date)
    // },
    getData(){
      this.getBalance()
      this.getIncome()
      this.getOutcome()
      this.getGoals()
      //this.getSavings()
    },
    refreshData(refresh_by_date){
      // this.loading = true
      // setTimeout(() => this.loading = false, 1200)
      let filter = {
        start_date: this.start_date != '' ? this.start_date : this.$dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_date: this.end_date != '' ? this.end_date : this.$dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
      }

      this.getIncome(filter)
      this.getOutcome(filter)
      this.getGoals(filter)
      //this.getSavings(filter)
      if(refresh_by_date == false){
        this.getBalance()
      }
    },
    getBalance(filter){
      this.getDashCounter('balance', filter)
    },
    getIncome(filter){
      this.getDashCounter('income', filter)
    },
    getOutcome(filter){
      this.getDashCounter('outcome', filter)
    },
    getGoals(filter){
      this.getDashCounter('goals', filter)
    },
    // getSavings(filter){
    //   this.getDashCounter('savings', filter)
    // },

    getDashCounter(kind, filter = {}){
      this.loadings[kind] = true
      Api.DashCounter.showByCompany(this.activeCompanyId, kind, filter).then(r=>r.data).then(d=>{
        this.all_data[kind] = d
      }).catch((err) => {
        console.log(err);
      }).finally(()=>{
        this.loadings[kind] = false
      })
    }
  },
  computed: {
    names() {
      return null
    },
    ...mapState({
      activeCompanyId: state => state.App.activeCompanyId
    }),
  },

  mounted () {
    this.getData()
  },
  watch: {
    start_date(){
      this.refreshData(true)
    },
    activeCompanyId(){
      this.refreshData(false)
    }
  },
  
}
</script>

<style lang="scss" scoped>

</style>